import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-24 bg-[#0f0a2e] overflow-hidden" data-id="element-277">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-279">
          {/* Content Left */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-280">
            <span className="text-[#d4af37] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-281">
              La Solución
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-282">
              Un Sistema de Formación Progresivo, Estructurado y Profesional
            </h2>
            <div className="space-y-6 text-lg text-purple-100 font-light" data-id="element-283">
              <p data-id="element-284">
                El{' '}
                <span className="font-semibold text-white" data-id="element-285">
                  Sistema Profesional de Reiki
                </span>{' '}
                no es un ebook más. Es una formación completa de 3 niveles
                diseñada con rigor pedagógico para llevarte desde los
                fundamentos hasta el dominio avanzado.
              </p>
              <p data-id="element-286">
                Cada nivel construye sobre el anterior, creando una base sólida
                de conocimiento y práctica que te permitirá ejercer con
                confianza, ética y profesionalismo.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mt-10" data-id="element-287">
              {['3 Niveles Progresivos', 'Metodología Estructurada', 'Herramientas Prácticas'].map((tag, i) => <span key={i} className="px-4 py-2 bg-purple-900/40 border border-purple-700/50 rounded-full text-sm text-purple-200" data-id="element-288">
                  {tag}
                </span>)}
            </div>
          </motion.div>

          {/* Images Right */}
          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-289">
            <div className="absolute inset-0 bg-[#6d28d9] blur-[100px] opacity-20 rounded-full" data-id="element-290" />

            <div className="relative z-10 flex justify-center" data-id="element-291">
              <img src="https://cdn.magicpatterns.com/uploads/2LpSGmgWzAztZZHhaMT6RV/20260219_2030_Image_Generation_simple_compose_01khw3svy6f3srpey11zp1m4j5.png" alt="Manual Profesional de Reiki Nivel I" className="w-2/3 shadow-2xl rounded-sm transform hover:-translate-y-2 transition-transform duration-500" data-id="element-292" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}